// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"LanguageButton_dropdown__QJqHu","item":"LanguageButton_item___quiE"};